import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Layout = () => {
  return (
    <>
      <Navbar />
      <main className="main-content">
        <section className="hero is-fullwidth bg-main">
          <Outlet />
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Layout;
